import CardEstatistica from '../../componentes/CardEstatistica';
import { IconCancel } from '../../componentes/Icons';
import './Financeiro.css';

const FinanceiroSection = ({
    financeiroStartDate,
    setFinanceiroStartDate,
    financeiroEndDate,
    setFinanceiroEndDate,
    periodRevenue,
    formatCurrency,
    periodExpenses,
    periodNetProfit,
    newExpense,
    setNewExpense,
    handleAddExpense,
    expenses,
    handleDeleteExpense
}) => {
    return (
        <div className="section-financeiro fade-in">
            <div className="section-header-row financeiro-header-row">
                <h2 className="section-main-title">Gestão Financeira</h2>
            </div>

            <div className="stats-container">
                <CardEstatistica
                    title="Faturamento"
                    value={formatCurrency(periodRevenue)}
                    hint="Ganhos brutos"
                    icon={<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>}
                    color="#D4AF37"
                />
                <CardEstatistica
                    title="Despesas"
                    value={formatCurrency(periodExpenses)}
                    hint="Gastos no período"
                    icon={<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 9l6 6 6-6" /></svg>}
                    color="#ff4d4d"
                />
                <CardEstatistica
                    title="Lucro Líquido"
                    value={formatCurrency(periodNetProfit)}
                    hint="O que sobra no bolso"
                    icon={<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" /></svg>}
                    color="#4dff88"
                />
            </div>

            <div className="admin-grid-layout">
                <div className="admin-card">
                    <h3 className="card-title">Nova Despesa</h3>
                    <div className="modern-form">
                        <div className="form-group">
                            <label>Descrição</label>
                            <input
                                type="text"
                                placeholder="Ex: Aluguel, Lâminas, Luz..."
                                value={newExpense.description}
                                onChange={(e) => setNewExpense({ ...newExpense, description: e.target.value })}
                                className="modern-input"
                            />
                        </div>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Valor (R$)</label>
                                <input
                                    type="text"
                                    placeholder="0,00"
                                    value={newExpense.amount}
                                    onChange={(e) => setNewExpense({ ...newExpense, amount: e.target.value })}
                                    className="modern-input"
                                />
                            </div>
                            <div className="form-group">
                                <label>Data</label>
                                <input
                                    type="date"
                                    value={newExpense.date}
                                    onChange={(e) => setNewExpense({ ...newExpense, date: e.target.value })}
                                    className="modern-input"
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Categoria</label>
                            <select
                                value={newExpense.category}
                                onChange={(e) => setNewExpense({ ...newExpense, category: e.target.value })}
                                className="modern-input"
                            >
                                <option value="Fixa">Fixa</option>
                                <option value="Variável">Variável</option>
                                <option value="Produtos">Produtos</option>
                                <option value="Outros">Outros</option>
                            </select>
                        </div>


                        <button className="modern-btn primary full-width" onClick={handleAddExpense}>
                            Lançar Despesa
                        </button>
                    </div>
                </div>

                <div className="admin-card">
                    <h3 className="card-title">Lista de Despesas</h3>
                    <div className="expenses-list">
                        {expenses.length > 0 ? (
                            expenses
                                .sort((a, b) => b.date.localeCompare(a.date))
                                .map(exp => (
                                    <div key={exp.id} className="expense-item">
                                        <div className="expense-info">
                                            <div className="expense-main">
                                                <span className="expense-desc">{exp.description}</span>
                                                <span className={`expense-cat-tag ${exp.category.toLowerCase()}`}>{exp.category}</span>
                                            </div>
                                            <span className="expense-date-sm">{exp.date.split('-').reverse().join('/')}</span>
                                        </div>
                                        <div className="expense-action-group">
                                            <span className="expense-val-negative">- {formatCurrency(exp.amount)}</span>
                                            <button className="expense-delete" onClick={() => handleDeleteExpense(exp.id)}>
                                                <IconCancel />
                                            </button>
                                        </div>
                                    </div>
                                ))
                        ) : (
                            <p className="empty-msg">Nenhuma despesa lançada.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinanceiroSection;
